const createDocumentVersionArray = (documentVersionArray, type) => {
  const defaultOptions = {
    name: 'Todos',
    id: 'all',
  }
  const documentArray =
    documentVersionArray.map((documentVersion) => ({
      name: String(documentVersion?.[type]),
      id: String(documentVersion?.[type]),
    })) || []
  return [...documentArray, defaultOptions]
}

export default createDocumentVersionArray
